import React from "react";
import Slide from "@mui/material/Slide";
import type { SlideProps } from "@mui/material/Slide";

export const Transition = React.forwardRef<unknown, SlideProps>(
  function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  }
);
